import { createContext } from "react";
import { isBrowser, getCookie } from "@helpers/browser";

export const INFLUENCER_DATA_COOKIE = "influencerData";

function getInfluencerDataFromCookie() {
  if (!isBrowser) return null;
  const raw = getCookie(INFLUENCER_DATA_COOKIE);
  if (!raw) return null;
  try {
    return JSON.parse(decodeURIComponent(raw));
  } catch {
    return null;
  }
}

export const defaultStoreContext = {
  _checkout: { lineItems: [], webUrl: null },
  trackCartProduct: [],
  addTrackCartProduct: () => {},
  products: [],
  shop: {},
  customerAccessToken:
    isBrowser && getCookie("accessToken") != null ? getCookie("accessToken") : null,
  sideCart: false,
  isActionInProgress: false,
  saleColors: null,
  seoDescriptionLinks: null,

  shippingFees: null,
  searchIndex: null,

  influencersData: null,
  influencerData: getInfluencerDataFromCookie(),
  setInfluencerDataProvider: () => {},
};

const StoreContext = createContext(defaultStoreContext);

export default StoreContext;
